<template>
  <main class="detail-student">
    <div class="row">
      <div class="col-md-12 top-wrapper">
        <TopTemplate>
          <template #left-element>
            <a @click="$router.go(-1)" class="btn btn-outline-primary button" :disabled="loading">
              <i class="arrow left" />
              {{ $t("button.retour") }}
            </a>
          </template>

          <template v-if="statusSchoolYear" #right-element>
            <div class="d-flex buttons-wrapper">
              <router-link :to="{name: 'EditStudent', params: {id: referenceId}}" class="btn button btn-primary" :disabled="loading">
                <i class="icon-edit-03" />
                {{ $t("button.edit") }}
              </router-link>
              <!-- <a class="btn btn-outline-primary button" :disabled="loading" @click.prevent="deleteStudent(referenceId)">
                <i class="icon-trash" />
                {{ $t("button.delete") }}
              </a> -->
            </div>
          </template>
        </TopTemplate>
      </div>
    </div>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-if="!loading" class="row top-part">
      <div class="col-md-12">
        <div class="coor-wrapper eleve_infos">
          <div class="part-left">
            <div class="image-avatar">
              <!-- <img v-if="reference.photo === null" class="img-avatar" :src="'/storage/avatar/image.png'" /> -->
              <img v-if="reference.photo" class="img-avatar" :src="reference.photo" />
              <img v-else class="img-avatar" src="/images/avatar_student.png" />
            </div>
            <div class="name-wrapper">
              <div class="full-name">
                <span class="name">{{ reference.last_name }}&nbsp;</span>
                <span class="name_propre">{{ reference.first_name }}</span>
              </div>

              <span v-if="getGender(reference.student_gender) && reference.student_gender === 0" class="birth"
                >{{ getGender(reference.student_gender) }}<span v-if="reference.birthday">, Né le {{ moment(reference.birthday).format("DD-MM-YYYY") }}</span
                ><span v-if="reference.place_of_birth">, à {{ reference.place_of_birth }}</span></span
              >
              <span v-if="getGender(reference.student_gender) && reference.student_gender === 1" class="birth"
                >{{ getGender(reference.student_gender) }}<span v-if="reference.birthday">, Née le {{ moment(reference.birthday).format("DD-MM-YYYY") }}</span
                ><span v-if="reference.place_of_birth">, à {{ reference.place_of_birth }}</span></span
              >
              <span v-if="!getGender(reference.student_gender)" class="birth"
                ><span v-if="reference.birthday">
                  Né le
                  {{ moment(reference.birthday).format("DD-MM-YYYY") }}</span
                ></span
              >
              <span v-if="!getGender(reference.student_gender)" class="birth"
                ><span v-if="reference.place_of_birth">, à {{ reference.place_of_birth }}</span>
              </span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="part-right">
              <span>{{ $t("eleve.formDetails.niveau") }}</span>
              <span class="niveau-eleve" v-if="reference.class_types && !reference.class">{{ reference.class_types.name }}</span>
              <span class="class-eleve" v-if="reference.class">{{ reference.class.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="existStudent">
      <div v-if="!loading && (reference.phone || reference.email)" class="wrapper-bande">
        <div class="row g-0">
          <div class="col-md-12">
            <h4 class="custom-title">{{ $t("title.contact") }}</h4>
          </div>
          <div class="col-md-6">
            <div class="detail-wrapper">
              <p>
                <strong>{{ $t("eleve.formDetails.phone") }} </strong><span v-if="reference.phone">{{ formatPhone(reference.phone) }}</span
                ><span v-else>{{ $t("common.nonRembler") }}</span>
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <!--v-if-->
            <div>
              <strong>{{ $t("eleve.formDetails.email") }}</strong
              ><span v-if="reference.email">{{ reference.email }}</span
              ><span v-else>{{ $t("common.nonRembler") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="row">
      <div v-for="(val, index) in reverseParents" :key="index" class="col-md-6-- col-6-- top-part" :class="getClasseName(reference.parents, reference.parents_tuteur)">
        <div v-if="val.gender == 1" class="part">
          <h4 class="custom-title">{{ $t("eleve.formDetails.mother") }}</h4>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.firstName") }}</strong>
              <span v-if="val.first_name" class="name_propre">{{ val.first_name }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.lastName") }}</strong>
              <span v-if="val.last_name" class="lastName_propre">{{ val.last_name }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.phone") }}</strong>
              <span v-if="val.phone">{{ formatPhone(val.phone) }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.fonction") }}</strong>
              <span v-if="val.function">{{ val.function }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.lieu") }}</strong>
              <span v-if="val.lieu_travail">{{ val.lieu_travail }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.email") }}</strong>
              <span v-if="val.email">{{ val.email }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.address") }}</strong>
              <span v-if="val.addresse">{{ val.addresse }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.ville") }}</strong>
              <span v-if="val.ville">{{ val.ville }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.code") }}</strong>
              <span v-if="val.code_postale">{{ val.code_postale }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.pays") }}</strong>
              <span v-if="val.pays">{{ val.pays }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
        </div>
        <div v-if="val.gender == 0" class="part">
          <h4 class="custom-title">{{ $t("eleve.formDetails.father") }}</h4>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.firstName") }}</strong>
              <span v-if="val.first_name" class="name_propre">
                {{ val.first_name }}
              </span>
              <span v-else> {{ $t("common.nonRembler") }} </span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.lastName") }}</strong>
              <span v-if="val.last_name" class="lastName_propre">{{ val.last_name }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.phone") }}</strong>
              <span v-if="val.phone">{{ formatPhone(val.phone) }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.fonction") }}</strong>
              <span v-if="val.function">{{ val.function }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.lieu") }}</strong>
              <span v-if="val.lieu_travail">{{ val.lieu_travail }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.email") }} </strong>
              <span v-if="val.email">{{ val.email }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.address") }}</strong>
              <span v-if="val.addresse">{{ val.addresse }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.ville") }}</strong>
              <span v-if="val.ville"> {{ val.ville }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.code") }}</strong>
              <span v-if="val.code_postale">{{ val.code_postale }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.pays") }}</strong>
              <span v-if="val.pays">{{ val.pays }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
        </div>
      </div>

      <div v-if="tuteur" class="col-md-6-- col-6-- top-part" :class="getClasseName(reference.parents, reference.parents_tuteur)">
        <div class="part">
          <h4 class="custom-title">{{ $t("eleve.formDetails.tuteur") }}</h4>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.firstName") }}</strong>
              <span v-if="tuteur.first_name" class="name_propre">{{ tuteur.first_name }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.lastName") }}</strong>
              <span v-if="tuteur.last_name" class="lastName_propre">{{ tuteur.last_name }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.phone") }}</strong>
              <span v-if="tuteur.phone">{{ formatPhone(tuteur.phone) }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.relation") }}</strong>
              <span v-if="tuteur.relation_eleve">{{ tuteur.relation_eleve }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.email") }}</strong>
              <span v-if="tuteur.email">{{ tuteur.email }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.address") }}</strong>
              <span v-if="tuteur.addresse">{{ tuteur.addresse }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.ville") }}</strong>
              <span v-if="tuteur.ville">{{ tuteur.ville }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.code") }}</strong>
              <span v-if="tuteur.code_postale">{{ tuteur.code_postale }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.pays") }}</strong>
              <span v-if="tuteur.pays">{{ tuteur.pays }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="wrapper-bande">
      <div class="row g-0">
        <div class="col-md-12">
          <h4 class="custom-title">{{ $t("title.situatuinFamille") }}</h4>
        </div>
        <div class="col-md-6">
          <div class="detail-wrapper">
            <p>
              <strong>{{ $t("eleve.formDetails.situationEnfant") }}</strong>
              <span v-if="reference.student_situations && reference.student_situations.student_situation">{{ reference.student_situations.student_situation.situation }}</span>
              <span v-else> {{ $t("common.nonRembler") }}</span>
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <div v-if="reference.parent_situations && length > 0">
            <div class="detail-wrapper">
              <p>
                <strong>{{ $t("eleve.formDetails.situationParents") }}</strong>
                <span v-for="(item, index) in reference.parent_situations" :key="index">
                  <span v-if="item.parent_situation && item.parent_situation.situation" class="p-2">
                    {{ item.parent_situation.situation }}
                  </span>
                  <span v-if="length <= 1 && item.parent_situation === null" class="p-2"> {{ $t("common.nonRembler") }}</span>
                </span>
              </p>
            </div>
          </div>
          <div v-if="length === 0">
            <strong>{{ $t("eleve.formDetails.situationParents") }}</strong
            ><span> {{ $t("common.nonRembler") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading" class="wrapper-bande">
      <div class="row g-0">
        <div class="col-md-12">
          <h4 class="custom-title">{{ $t("title.scolaire") }}</h4>
        </div>
        <div v-if="reference.scolarities && reference.scolarities.length">
          <div v-for="(item, index) in reference.scolarities" :key="index" class="col-md-12 d-flex">
            <div class="col-md-3">
              <div class="detail-wrapper">
                <p>
                  <strong>{{ $t("eleve.formDetails.anneeScolaire") }}</strong>
                  {{ item?.school_year ? item.school_year.school_year : $t("common.nonRembler") }}
                </p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="detail-wrapper">
                <p>
                  <strong>{{ $t("eleve.formDetails.niveaux") }}</strong>
                  {{ item?.class_type ? item.class_type.name : $t("common.nonRembler") }}
                </p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="detail-wrapper">
                <p>
                  <strong>{{ $t("eleve.formDetails.classe") }}</strong>
                  {{ item?.class ? item.class.name : $t("common.nonRembler") }}
                </p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="detail-wrapper">
                <p>
                  <strong>{{ $t("eleve.formDetails.school") }}</strong>
                  {{ item?.school_name ? item.school_name : $t("common.nonRembler") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-md-4">
              <div class="detail-wrapper">
                <label>{{ $t("eleve.formDetails.niveaux") }}</label>
                <p>{{ $t("common.nonRembler") }}</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="detail-wrapper">
                <label>{{ $t("eleve.formDetails.anneeScolaire") }}</label>
                <p>{{ $t("common.nonRembler") }}</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="detail-wrapper">
                <label>{{ $t("eleve.formDetails.school") }}</label>
                <p>{{ $t("common.nonRembler") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading" class="wrapper-bande">
      <div class="row g-0">
        <div class="col-md-12">
          <h4 class="custom-title">{{ $t("title.activites") }}</h4>
        </div>
        <div v-if="reference.activities && reference.activities.length > 0">
          <div v-for="(item, index) in reference.activities" :key="index" class="col-md-12 d-flex">
            <div class="col-md-6">
              <div class="detail-wrapper">
                <div class="spec-label">
                  <p>
                    <strong>{{ $t("eleve.formDetails.activite") }}</strong>
                    {{ item?.activity ? item.activity.name : $t("common.nonRembler") }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="item.activity" class="col-md-6">
              <div class="detail-wrapper">
                <div class="spec-label">
                  <p>
                    <strong>{{ $t("eleve.formDetails.preciser") }}</strong>
                    {{ item?.description ? item.description : $t("common.nonRembler") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-md-6">
              <div class="detail-wrapper">
                <label class="spec-label">{{ $t("eleve.formDetails.activite") }}</label>
                <p>{{ $t("common.nonRembler") }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-wrapper">
                <label class="spec-label">{{ $t("eleve.formDetails.preciser") }}</label>
                <p>{{ $t("common.nonRembler") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- section services -->
    <div v-if="!loading && existPay" class="wrapper-bande">
      <div class="row g-0">
        <div class="col-md-12">
          <h4 class="custom-title">{{ $t("title.services") }}</h4>
        </div>
        <div v-if="services.length > 0" class="items-wrapper">
          <div v-for="(item, index) in reference.services" :key="index" class="col-md-4">
            <div v-if="item && item.name" class="service-item">
              <span class="nameService"
                ><strong>{{ item.name }}</strong>
              </span>
            </div>
            <div v-if="item && item.student_service_price_discounted">
              <span class="dis">
                {{ item.student_service_price_discounted }}
                {{ $t("common.dt") }}
              </span>
            </div>
            <div>
              <span v-if="item && item.discount_type == '1'" class="discount">{{ $t("eleve.formDetails.discount") }}{{ item.discount_value }} {{ $t("common.percent") }}</span>
              <span v-if="item && item.discount_type == '2'" class="discount">{{ $t("eleve.formDetails.discount") }}{{ item.discount_value }} {{ $t("common.dt") }} </span>
            </div>
          </div>
        </div>
        <div v-else>
          <span>{{ $t("common.nonRembler") }}</span>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="wrapper-bande add-info">
      <div class="row g-0">
        <div class="col-md-12">
          <h4 class="custom-title">{{ $t("title.commentaires") }}</h4>
          <p
            :class="{
              'arabic-text': checkLanguag(reference.additional_information),
            }"
          >
            <span v-if="reference.additional_information">{{ reference.additional_information }}</span>
            <span v-else> {{ $t("common.nonRembler") }}</span>
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import StudentService from "../../services/student.service";
import ServicesService from "../../services/services.service";
import {parsePhoneNumberFromString} from "libphonenumber-js";
import moment from "moment";
import {mapGetters} from "vuex";
export default {
  name: "DetailsStudent",
  components: {
    TopTemplate,
  },
  filters: {
    reverse(reference) {
      return reference.slice().reverse();
    },
  },
  data() {
    return {
      loading: false,
      referenceId: null,
      parents: [],
      moment: null,
      years: [],
      status: 0,
      existPay: false,
      existStudent: false,
      length: 0,
      school_year: [],
      scolarities: [
        {
          school_year: null,
          school_name: "",
          class_type_id: null,
        },
      ],
      services: [
        {
          service_id: "",
          name: "",
          discount_type: null,
          discount_value: null,
        },
      ],
      reference: {},
      tuteur: {},
      //baseURL:"/storage/public/users/photos/eleve8.png"
    };
  },
  created() {
    this.referenceId = this.$route.params.id;
    this.moment = moment;
  },
  mounted() {
    // this.ListYears();
    this.getDetails();
    this.moduleUser();
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusSchoolYear() {
      return this.getPassageYears.status;
    },
    reverseParents() {
      return this.parents.slice().reverse();
    },
    userModules() {
      return this.$store.state?.auth?.user?.modules;
    },
  },
  methods: {
    formatPhone(value) {
      const phoneNumber = parsePhoneNumberFromString(value, "TN");
      return phoneNumber.formatNational();
    },
    checkIfElementNameIsEleves() {
      return this.userModules.some((element) => element.name === this.$t("modules.student"));
    },
    checkIfElementPayIsEleves() {
      return this.userModules.some((element) => element.name === this.$t("modules.payment"));
    },
    moduleUser() {
      this.existPay = this.checkIfElementPayIsEleves();
      this.existStudent = this.checkIfElementNameIsEleves();
    },

    ListYears() {
      StudentService.getAllyear({
        params: {},
      }).then(
        (response) => {
          this.status = response.data.data;
          this.status.forEach((element) => {
            if (element.is_active === 0) {
              this.years.push(element);
            }
          });
        },
        (error) => {}
      );
    },
    getDetails() {
      this.loading = true;
      StudentService.get(this.referenceId)
        .then((response) => {
          this.reference = response.data.data;
          this.tuteur = response.data.data.parents_tuteur[0];
          this.tuteurTab = response.data.data.parents_tuteur;

          if (this.reference.parents.length > 0) {
            if (this.reference.parents[0].first_name || this.reference.parents[0].last_name || this.reference.parents[0].email || this.reference.parents[0].phone) {
              this.parents = this.reference.parents;
            } else {
              this.parents = [];
            }
          }
          this.scolarities = response.data.data.scolarities;
          this.services = response.data.data.services;
          this.reference.services_list.forEach((element, index) => {
            this.services[index].name = element.name;
          });
          this.length = this.reference.parent_situations.length;
          this.scolarities.forEach((element, index) => {
            this.years.find((x) => {
              if (x.id === element.school_year) {
                this.school_year.push(JSON.parse(JSON.stringify(x.school_year)));
              }
            });
          });
          this.school_year.forEach((element, index) => {
            this.scolarities[index].school_year = element;
          });

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          if (error.response && error.response.status === 404) {
            this.$router.push("/error-404");
          }
        });
    },
    getClasseName(parents, tuteur) {
      if (parents?.length == 2 && tuteur?.length) {
        return "col-md-4";
      } else if (parents?.length == 2 && !tuteur?.length) {
        return "col-md-6";
      } else if (parents?.length == 1 && tuteur?.length) {
        return "col-md-6";
      } else if (parents?.length == 1 && !tuteur?.length) {
        return "col-md-12";
      }
    },
    checkLanguag(val) {
      const arabic = /[\u0600-\u06FF]/;
      return arabic.test(val); // displays true
    },
    getGender(id) {
      if (id === 0) {
        return "Garçon";
      } else if (id === 1) {
        return "Fille";
      }
    },

    getType(id) {
      if (id === 1) {
        return "%";
      } else if (id === 2) {
        return "DT";
      }
    },
    deleteStudent(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });

      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteStudent"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.studentDeleted"), "", "success");
            StudentService.delete(id).then(
              () => {
                this.$router.push({name: "student_list"});
              },
              (error) => {
                this.loading = false;
              }
            );
            // StudentService.delete(id);
            // this.$router.push({ name: 'student_list' });
          }
        });
    },
  },
};
</script>
<style scoped>
.class-eleve {
  word-wrap: break-word;
}
</style>
